(() => {
  if (!document.body.classList.contains('ak-guided-page')) return;
  const strings = JSON.parse(document.getElementById('ak-guided-strings')?.textContent || '{}');
  const message = (key, replacements={}) => Object.entries(replacements).reduce((text,[name,value]) => text.replaceAll(`{${name}}`,value), strings[key] || key);
  const indiaParts = new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
  const dateLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'en-IN',{timeZone:'UTC',weekday:'short',day:'numeric',month:'short'});
  function updateDispatch() {
    const parts=Object.fromEntries(indiaParts.formatToParts(new Date()).map(p=>[p.type,p.value]));
    const today=new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
    const minutes=(+parts.hour)*60+(+parts.minute);
    document.querySelectorAll('[data-ak-dispatch]').forEach(element=>{
      const holidays=new Set((element.dataset.holidays||'').split(/[\s,]+/).filter(v=>/^\d{4}-\d{2}-\d{2}$/.test(v)));
      const working=d=>d.getUTCDay()!==0&&!holidays.has(d.toISOString().slice(0,10));
      let text;
      if(working(today)&&minutes<840){const remaining=840-minutes;text=message('dispatch_today',{hours:Math.floor(remaining/60),minutes:remaining%60});}
      else {
        const next=new Date(today);next.setUTCDate(next.getUTCDate()+1);
        let advanced=1;
        while(!working(next)&&advanced<370){next.setUTCDate(next.getUTCDate()+1);advanced++;}
        text=advanced===1?message('dispatch_tomorrow'):message('dispatch_date',{date:dateLabel.format(next)});
      }
      const output=element.querySelector('[data-ak-dispatch-message]');if(output&&output.textContent!==text)output.textContent=text;
    });
  }
  function closeVideo(video) {
    const holder = video?.querySelector('[data-ak-video-player]');
    const trigger = video?.querySelector('[data-ak-video-trigger]');
    const tools = video?.querySelector('[data-ak-video-tools]');
    if (!holder || !trigger) return;
    holder.querySelector('iframe')?.remove();
    trigger.hidden = false;
    trigger.setAttribute('aria-expanded', 'false');
    if (tools) tools.hidden = true;
    trigger.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const video = event.target.closest('[data-ak-video-id]');
    if (video?.querySelector('iframe')) {
      event.preventDefault();
      closeVideo(video);
    }
  });
  document.addEventListener('click',async event=>{
    const copy=event.target.closest('[data-ak-copy]');
    if(copy){
      const status=copy.closest('.ak-offers')?.querySelector('[data-ak-copy-status]');
      try{await navigator.clipboard.writeText(copy.dataset.akCopy);if(status)status.textContent=message('code_copied',{code:copy.dataset.akCopy});}
      catch{if(status)status.textContent=message('copy_manually',{code:copy.dataset.akCopy});}
    }
    const close = event.target.closest('[data-ak-video-close]');
    if (close) {
      closeVideo(close.closest('[data-ak-video-id]'));
      return;
    }
    const trigger=event.target.closest('[data-ak-video-trigger]');
    if(trigger){
      const video=trigger.closest('[data-ak-video-id]');const id=video?.dataset.akVideoId;
      if(!/^[A-Za-z0-9_-]{11}$/.test(id||''))return;
      const holder=video.querySelector('[data-ak-video-player]');if(!holder||holder.querySelector('iframe'))return;
      const frame=document.createElement('iframe');
      frame.src=`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      frame.title=video.dataset.akVideoTitle||message('video');frame.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';frame.className='ak-video-frame';
      trigger.hidden = true;
      trigger.setAttribute('aria-expanded', 'true');
      holder.append(frame);
      const tools = video.querySelector('[data-ak-video-tools]');
      if (tools) tools.hidden = false;
      (video.querySelector('[data-ak-video-close]') || frame).focus({ preventScroll: true });
    }
  });
  updateDispatch();setInterval(updateDispatch,60000);document.addEventListener('shopify:section:load',updateDispatch);
})();
